import { ComponentPropsWithoutRef } from 'react';

export const CopyIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <path
        d="M19.5 20H17a1 1 0 0 1 0-2h2.5a.506.506 0 0 0 .5-.5v-14a.506.506 0 0 0-.5-.5h-12a.506.506 0 0 0-.5.5V6a1 1 0 0 1-2 0V3.5A2.503 2.503 0 0 1 7.5 1h12A2.503 2.503 0 0 1 22 3.5v14a2.503 2.503 0 0 1-2.5 2.5z"
        data-original="#000000"
      />
      <path
        d="M15.5 23h-11A2.503 2.503 0 0 1 2 20.5v-13A2.503 2.503 0 0 1 4.5 5h11A2.503 2.503 0 0 1 18 7.5v13a2.503 2.503 0 0 1-2.5 2.5zM4.5 7a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5z"
        data-original="#000000"
      />
    </svg>
  );
};
